module.exports = __webpack_public_path__ + "img/internet_connected.f3e98b72.svg";